module.exports = __webpack_public_path__ + "img/zcgy_nav.cbb4efd9.png";